/**
 * GainIcon — sanitized from `assets/newSvg/gain.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function GainIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M12.9999,2.04938 C17.7244,2.51845 21.4815,6.27559 21.9506,11 L19.9999,11 C19.4477,11 18.9999,11.4477 18.9999,12 C18.9999,12.5523 19.4477,13 19.9999,13 L21.9506,13 C21.4488,18.0533 17.1853,22 11.9999,22 C6.81459,22 2.55104,18.0533 2.04932,13 L3.99994,13 C4.55223,13 4.99994,12.5523 4.99994,12 C4.99994,11.4477 4.55223,11 3.99994,11 L2.04932,11 C2.51839,6.27559 6.27552,2.51845 10.9999,2.04938 L10.9999,4 C10.9999,4.55229 11.4477,5 11.9999,5 C12.5522,5 12.9999,4.55229 12.9999,4 L12.9999,2.04938 Z M17.78,6.22 L12.9372498,8.68549993 L12.5639368,8.88160297 L11.9538121,9.19234339 C11.2331508,9.5614361 10.500066,9.964354 9.94932,10.5151 C8.97764,11.4868 8.86,13.1027 9.87861,14.1213 C10.8972,15.1399 12.5132,15.0223 13.4849,14.0506 C13.95692,13.57858 14.320364,12.972532 14.6470088,12.3551656 L15.1183487,11.4359659 L15.4802061,10.7381492 L17.78,6.22 Z M13.1623,10.8376 L13.0496625,11.0476 L12.9368,11.2642 C12.7283,11.6663667 12.5106333,12.0860333 12.2392398,12.4363366 L12.0706,12.6364 C11.7926,12.9144 11.4458,12.8601 11.2928,12.7071 C11.15519,12.56949 11.097365,12.27474 11.2898381,12.0145041 L11.3625,11.9304 C11.6815833,11.63565 12.0874028,11.4036778 12.493037,11.1896917 L12.7357,11.0631 C12.8816,10.9875 13.0252,10.913 13.1623,10.8376 Z"
        fill={color}
      />
    </Svg>
  );
}

export default GainIcon;
